module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/store_images/4@2x_19c2b27d35b41afdf55f8ac7fabf53b6.png";